import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectPage } from '../../project.page';
import { DxButtonModule } from 'devextreme-angular';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-project-costs',
    imports: [CommonModule, DxButtonModule, RouterModule],
    providers: [ProjectPage],
    templateUrl: './project-costs.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-costs.page.css']
})

export class ProjectCostsPageComponent {


}
